import { theme } from 'src/config'
import styled from 'styled-components' 

export const StickyTableHeader = styled.th`
  min-width:  12rem;
  height:     10rem;
  position:   sticky;
  z-index:    12;
  left:       0;
  background: ${theme.color.white};
  border:     1px solid ${theme.color.alert};

  :hover {
    background-color: ${theme.color.white};
  }
`